import OrderIcon from '@mui/icons-material/RequestQuote';
import OrderList from './OrderList';
import OrderShow from './OrderShow';
import { AsideAddressWarning } from './AsideAddressWarning';
import { AsideFraudWarning } from './AsideFraudWarning';

export default {
    list: OrderList,
    show: OrderShow,
    icon: OrderIcon,
};

export { AsideAddressWarning, AsideFraudWarning };
